import { render } from "./Events.view.vue?vue&type=template&id=458dc003"
import script from "./Events.view.vue?vue&type=script&lang=js"
export * from "./Events.view.vue?vue&type=script&lang=js"

import "./Events.view.vue?vue&type=style&index=0&id=458dc003&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__